var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMediumBaggage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 26,
    viewBox: "0 0 14 26",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.676 12.531v10.647c0 1.217.935 2.204 2.125 2.313V10.22a2.326 2.326 0 0 0-2.125 2.313m10.785-2.313h-.004v15.273a2.326 2.326 0 0 0 2.125-2.314v-5.304q0-.002.002-.003v-5.34a2.324 2.324 0 0 0-2.122-2.313zM10.5.585A.583.583 0 0 0 9.918 0H4.386a.586.586 0 0 0-.584.585v9.611h-.52v15.317h.375V26h1.07v-.488h4.849V26h1.07v-.488h.373V10.196h-.52zM9.297 12.893a.27.27 0 0 1-.27.269H5.233a.27.27 0 0 1-.27-.27v-.535a.27.27 0 0 1 .27-.27h3.796a.27.27 0 0 1 .269.27zm.035-2.697h-4.36V1.168h4.36z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediumBaggage);
export default __webpack_public_path__ + "static/media/mediumBaggage.4d80478b1bb1546e9d4a8cd46f817406.svg";
export { ForwardRef as ReactComponent };